import auth from '../../../apis/auth';
import { ContextoVitrine, ParametrosPreview, RespostaPreview } from '../types';

// O cliente do yggdrasil já envia o x-tenant-id e o Bearer do usuário logado
// (definido em useAuth/refreshToken nos headers padrão do axios).

export const preVisualizarVitrine = async (dados: {
  context: ContextoVitrine;
  productIds: string[];
  settings: ParametrosPreview;
}): Promise<RespostaPreview> => {
  const { data } = await auth.post<RespostaPreview>(
    '/recomendacao/vitrine/preview',
    dados,
    { timeout: 5000 },
  );
  return data;
};
